import { ColumnsWithGroupAndFilteredFields } from "../models/windows/GetColumnsWithGroup";
import { CascadeValue } from "../models/analysiscodes/AnalysisCodes";


export function extractFieldsAndValues(response: any) {
  let fields: Array<{ [key: string]: any }> = [];
  let values: { [key: string]: string } = {};
  let keys = Object.keys(response.data.fields);
  keys.forEach((key) => {
    const fieldValue = response.data.fields[key];
    fields.push({
      ...fieldValue,
      filteredValues: fieldValue.ValidValues,
    });
    let propName = fieldValue.PropertyName;
    values[propName] = "";
  });
  fields.sort((a, b) => Number(a.FieldOrder) - Number(b.FieldOrder));
  return { fields, values };
}

export function updateCascadeChildOptions(
  child: ColumnsWithGroupAndFilteredFields,
  cascadeValues: CascadeValue[],
  value: string,
  setMetadata: (updater: (prev: any[]) => any[]) => void
) {
  const cascadedChildOptions = cascadeValues.filter(
    (c) => c.ParentValue === value
  );
  const filteredOptions = (child.ValidValues ?? []).filter((value) =>
    cascadedChildOptions.some((child) => value.Code === child.ChildValue)
  );

  const updatedOptions =
    filteredOptions.length > 0 ? filteredOptions : child.ValidValues;

  setMetadata((pre) => {
    return pre.map((p) => {
      if (p.PropertyName === child.PropertyName)
        return {
          ...p,
          filteredValues: updatedOptions,
        } as ColumnsWithGroupAndFilteredFields;
      return p;
    });
  });
}